module.exports = __webpack_public_path__ + "static/media/yaourt.872af0a8.svg";